import React, { useState, useEffect } from "react";

const API_URL =
  "https://www.api.cosmopolitan.edu.ng/index.php?studentid=23C-MED-NUC-0001&phonenumber=08060809145";

const Api = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch data from the API
    const fetchData = async () => {
      try {
        const response = await fetch(API_URL);
        const result = await response.json(); // Parse JSON response
        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div style={styles.container}>
        <div className="loader"></div>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.text}>API Data:</h2>
      <pre style={styles.pre}>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    padding: "20px",
    textAlign: "center",
  },
  text: {
    fontSize: "20px",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  pre: {
    background: "#f4f4f4",
    padding: "10px",
    borderRadius: "5px",
    textAlign: "left",
    maxWidth: "80%",
    overflowX: "auto",
  },
};

export default Api;
